import {
    SetToken,
    CustomUrlDrilldown,
    SwitchToTab,
    SetTimeRange,
    ResetTokens,
    UnsetTokens,
} from '@splunk/dashboard-event-handlers';
import type { PresetMap } from '@splunk/dashboard-types';

export default {
    eventHandlers: {
        'drilldown.customUrl': CustomUrlDrilldown,
        'drilldown.setToken': SetToken,
        'drilldown.setTimeRange': SetTimeRange,
        'drilldown.switchToTab': SwitchToTab,
        'drilldown.resetTokens': ResetTokens,
        'drilldown.unsetTokens': UnsetTokens,
    } as PresetMap['eventHandlers'],
};
